import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const SignaturesIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 58,
  height = 58,
  ...rest
}) => {
  return (
    <Icon
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFF"
          d="M4 51.952c0 1.1.9 2 2 2h31.843c1.1 0 2-.9 2-2V17.62c0-1.1-.61-2.662-1.356-3.47l-7.083-7.68C30.659 5.661 29.149 5 28.049 5H6c-1.1 0-2 .9-2 2z"
          className={styles.white}
        />
        <path
          stroke="#424242"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.5"
          d="M4 51.952c0 1.1.9 2 2 2h31.843c1.1 0 2-.9 2-2V17.62c0-1.1-.61-2.662-1.356-3.47l-7.083-7.68C30.659 5.661 29.149 5 28.049 5H6c-1.1 0-2 .9-2 2z"
        />
        <path
          stroke="#424242"
          strokeWidth="1.5"
          d="M30.049 5v9.633c0 .562.456 1.017 1.018 1.015l8.776-.028"
        />
        <path
          fill="#8C2A8E"
          d="m54.793 17.544.787.787c.4.4.4 1.049 0 1.449L35.243 40.118l-2.242-2.243 20.331-20.331a1.034 1.034 0 0 1 1.461 0M29.635 43.514l2.292-4.608 2.268 2.364z"
        />
        <path
          stroke="#424242"
          strokeLinecap="round"
          strokeWidth="1.5"
          d="M10.803 15.196h12.031M10.803 20.482h12.031M10.803 36h12.031M10.803 30.772H27.61M10.803 25.544h20.913"
        />
        <path
          fill="#424242"
          d="M12.633 44.91a100 100 0 0 0 1.96-2.095q.412-.45.808-.914.155-.183.308-.369c.3-.363.805-.605-.002-.455-.733.136-.39.011-.423.43-.022.271-.018.535-.058.806a13 13 0 0 1-.4 1.752c-.3 1.036-.677 2.05-.93 3.1-.111.466-.411 1.391-.021 1.81.434.464 1.375.125 1.833-.116.505-.266.914-.677 1.402-.97a8 8 0 0 1 1.7-.754 9.2 9.2 0 0 1 1.838-.399l-.722-.19c.374 1.193 1.074 2.596 2.538 2.33 1.273-.232 1.613-1.257 2.388-2.142.364-.416.81-.809 1.323-1.029a4 4 0 0 1 .332-.114c-.051.023.377-.03-.062 0 .303-.02.994-.108 1.13-.447.129-.32-.107-.448-.442-.426-1.58.103-3.054 1.021-4.024 2.241-.23.29-.402.616-.62.913a1.5 1.5 0 0 1-.18.226q-.309.303.546-.04c0-.009-.622-.623-.682-.722a6 6 0 0 1-.543-1.247c-.08-.257-.531-.21-.721-.19a12.2 12.2 0 0 0-4.72 1.514c-.26.15-1.297.658-1.375.953l-.074.05.75-.05a.4.4 0 0 1-.041-.09c.037-.095-.026-.412-.014-.534.1-1.029.5-2.059.813-3.038.31-.97 1.817-4.914-.512-4.35-.881.212-1.352.914-1.908 1.567a56 56 0 0 1-1.881 2.074 155 155 0 0 1-3.297 3.398c-.296.296.254.418.442.427.402.02.849-.165 1.13-.446q1.219-1.22 2.41-2.465"
        />
        <path
          fill="#424242"
          d="M14.74 42.059h1.117l.73-1.267h-.923l-.924.633zM14.74 47.634l1.405.412-.481.503-.924.224-.64-.224zM19.5 46.68l1.436.417v-.794h-1.087zM21.922 47.634l1.416.275v.294l-.937.228-.834-.228z"
        />
      </g>
    </Icon>
  )
}
